import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

import ct3_1min from '../assets/img/create-tracks/florariums/ct3_1min-min.jpg'
import ct3_2min from '../assets/img/create-tracks/florariums/ct3_2min-min.jpg'
import ct3_3min from '../assets/img/create-tracks/florariums/ct3_3min-min.jpg'
import ct3_4min from '../assets/img/create-tracks/florariums/ct3_4min-min.jpg'
import ct3_5min from '../assets/img/create-tracks/florariums/ct3_5min-min.jpg'
import ct3_6min from '../assets/img/create-tracks/florariums/ct3_6min-min.jpg'


const T3_3 = (props) => {
  const arrImgmin = [ ct3_1min, ct3_2min, ct3_3min, ct3_4min, ct3_5min, ct3_6min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + '/assets/ct3_1.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct3_2.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct3_3.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct3_4.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct3_5.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct3_6.jpg'}
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/create-tracks' >
      <ScrollToTopOnMount />
      <Trans i18nKey='T3_3'>
        <p>
          Сьогодні таке направлення фітодизайну як флораріум набуває все більшої популярності.<br/>
          Міні-сад у склі стане яскравою родзинкою у Вашому інтер’єрі.<br/>
          Живий оазис невибагливий у догляді. Він може бути різних форм та розмірів, настільний або підвісний.<br/>
          Завдяки власній індивідуальності флораріум ідеально підкреслить вишуканий стиль Вашого дизайну інтер'єру, додавши до нього частину неймовірної природи.
        </p>
        <p>
          Флораріум – це:<br/>
          - яскравий та вражаючий предмет декору; <br/>
          - міні-сад у склі, що зачаровує;<br/>
          - частина живої природи у Вашому приміщенні.
        </p>
        <p className="prise">
          Ціна одного флораріума починається від 500 грн та залежить від форми, розміру, кількості наповнення рослинами та їх виду.
        </p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(T3_3)


// WEBPACK FOOTER //
// ./src/page/T3_3.jsx